import { __assign } from "tslib";
import React from 'react';
import MoveNotificationLoadable from './MoveNotification/MoveNotificationLoadable';
var renderer = function (notification, removeNotification) {
    switch (notification.type) {
        case '@FBS_Remove':
        case '@FBS_Save':
            return (React.createElement(MoveNotificationLoadable, __assign({ id: notification.id, queueName: notification.queueName, type: notification.type }, notification.params)));
        default:
            return null;
    }
};
export default renderer;
//# sourceMappingURL=notificationsRenderFunc.js.map